/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect, useState, useRef } from "react";
import "./MPHHeaderMain.scss";
import logo from "../../../assets/images/logo.png";
import menu from "../../../assets/images/menu.png";
import { useNavigate } from "react-router-dom";
import MPHButton from "../MPHButtons/MPHButton";
import useAuth from "src/context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import "bootstrap";
import { AUTH_ROUTES, BASIC_SSO_AUTH, CHAIN_ID, HOTEL_FIND_LINK, INTERNAL_REDIRECTION_URLS } from "src/config/constants";
import { useStorage } from "src/utils/storage";
import { useApiAxiosRequests } from "src/utils/ApiService/MPHApis";
import { getEmail, isSessionValid } from "src/utils/session";
import { errorToast } from "src/utils/toast";
import { useBlockUIContext } from "ns-react-block-ui";

const MPHHeaderMain = ({ active }: any) => {
  const storage = useStorage();
  const { setTokens, setUserProfile, user, clearStorage, setOptIn } = useAuth();
  const { getCustomerByEmailLoggedIn, getCustomerLookUpAuthToken, getCRMSession, getCustomerLookUp } = useApiAxiosRequests();
  const navigate = useNavigate();
  const modifyReservationFormRef = useRef<HTMLFormElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { setBlockUI } = useBlockUIContext();
  const redirectUrl = `${HOTEL_FIND_LINK}reservation-list`;

  const getSession = async (
    profileId?: string,
    hasRetried = false
  ): Promise<{ session?: string; error?: string }> => {
    const store: any = storage.get("user_profile");
    if (!store) {
      return { error: "Unable to place request" };
    }

    let parsedStore: any;
    try {
      parsedStore = JSON.parse(store);
    } catch (error) {
      console.error("Failed to parse user profile from storage", error);
      return { error: "Unable to place request" };
    }

    const email =
      parsedStore && parsedStore.email ? parsedStore.email.toLowerCase() : "";
    if (!email) {
      return { error: "Unable to place request" };
    }

    setIsLoading(true);
    try {
      const params = {
        identifierName: "email",
        identifierValue: email,
      };
      const res: any = await getCustomerLookUp(params);
      if (!(res && res.data && res.data.id)) {
        return { error: "Unable to place request" };
      }

      const token: any = await getCustomerLookUpAuthToken(
        {
          GrantType: "CLIENT_CREDENTIALS",
          UserIPAddress: "127.0.0.1",
          UserType: "Hotel",
          BusinessContext: "WBSVC",
        },
        BASIC_SSO_AUTH,
        email
      );
      if (!(token?.data?.access_token)) {
        return { error: "Unable to place request" };
      }
      let memberId;
      if (
        res.data?.profiles &&
        res.data.profiles.length &&
        res.data.profiles[0].identifiers &&
        res.data.profiles[0].identifiers.length
      ) {
        const identifier = res.data.profiles[0].identifiers.find(
          (val: any) => val.type === "externalId"
        );
        memberId = identifier?.value;
      }

      const crmSession: any = await getCRMSession(
        {
          ChainId: CHAIN_ID,
          IDContext: "CRM",
          ProfileID: profileId || memberId || res.data.id,
          UserType: "Guest",
        },
        { token: token.data.access_token },
        email
      );

      if (crmSession?.data?.access_token) {
        return { session: crmSession.data.access_token };
      }

      if (!hasRetried && memberId && res.data.id) {
        return await getSession(res.data.id, true);
      }

      return {
        error: crmSession?.data?.error_description || "Unable to place request",
      };
    } catch (error) {
      console.error("Failed to get CRM session for modify reservation", error);
      return { error: "Unable to place request" };
    } finally {
      setIsLoading(false);
    }
  };

  const updateModifyReservationForm = (sessionValue: string) => {
    const form = modifyReservationFormRef.current;
    if (!form) {
      return false;
    }

    // const formatDate = (date: Date) => date.toISOString().split("T")[0];
    // const today = new Date();
    // const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    const payload: Record<string, string> = {
      // hotel: "8187",
      chain: CHAIN_ID ? String(CHAIN_ID) : "",
      Level: "Chain",
      // adult: "1,0",
      // arrive: formatDate(today),
      // depart: formatDate(tomorrow),
      // rooms: "1",
      "code-type": "promo",
      // promo: "",
      locale: "en_US",
      UserType: "Guest",
      session: sessionValue,
    };

    Object.entries(payload).forEach(([key, value]) => {
      const input = form.elements.namedItem(key) as HTMLInputElement | null;
      if (input) {
        input.value = value;
      } else {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = key;
        hiddenInput.value = value;
        form.appendChild(hiddenInput);
      }
    });

    return true;
  };

  const createBodyForFormPost = async () => {
    if (isLoading) {
      return;
    }

    setBlockUI({
      blocking: true,
      message: "Preparing your reservation. Please wait...",
    });

    const { session, error } = await getSession();
    if (session) {
      const formUpdated = updateModifyReservationForm(session);
      if (formUpdated) {
        modifyReservationFormRef.current?.submit();
      } else {
        errorToast("Unable to place request");
        setBlockUI({ blocking: false });
      }
    } else {
      errorToast(error || "Unable to place request");
      setBlockUI({ blocking: false });
    }
  };
  const navigateToRoute = (route: any, redirect?: any) => {
    if (redirect) {
      if (redirect === INTERNAL_REDIRECTION_URLS.MPH_VIEW_MODIFY_RESERVATIONS) {
        createBodyForFormPost();
      } else {
        window.open(redirect, "_blank");
      }
    } else {
      navigate(route);
      window.scrollTo(0, 0);
    }
  };

  const checkValidSession = async () => {
    const token: any = await storage.get("app_tokens");
    const profile: any = await storage.get("user_profile");
    if (token && profile) {
      const authToken = JSON.parse(token);
      const userExisting = JSON.parse(profile);
      if (authToken && authToken.token) {
        if (!isSessionValid(authToken.token)) {
          storage.clear();
          setTokens({});
          setUserProfile(null);
        } else {
          const user: any = await getCustomerByEmailLoggedIn({
            email: userExisting.email,
          });
          const customer: any =
            user &&
            user.data &&
            user.data.customers &&
            user.data.customers.customer &&
            user.data.customers.customer.length &&
            user.data.customers.customer[0];
          if (!customer || !customer.email) {
            return;
          }
          setUserProfile({
            method: "auth",
            email: getEmail(storage),
            previousStep: "",
            token: authToken.token,
            role: "User",
            isProfileExist: true,
            links: AUTH_ROUTES,
            profileName: (customer && customer.firstname) || "",
            loyalty_points: (customer && customer.loyalty_points) || 0,
          });
        }
      }
    } else {
      storage.clear();
      setTokens({});
      setUserProfile(null);
    }
  };

  useEffect(() => {
    checkValidSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storage]);

  return (
    <>      
      <nav className="navbar navbar-expand-lg navbar-light bg-light header-main bg-white fixed-top">
        <span className="navbar-brand">
          <img
            src={logo}
            alt="Logo"
            onClick={() => navigateToRoute(null, INTERNAL_REDIRECTION_URLS.Web)}
            className="d-inline-block align-top logo"
          />
        </span>
        <button
          className="navbar-toggler"
          style={{
            border: "none",
            outline: "none",
            boxShadow: "none",
          }}
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="d-block">
            <img src={menu} alt="" />
            <span className="menu-c d-block">Menu</span>
          </span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-between"
          id="navbarNavDropdown"
        >
          <ul
            className={
              "navbar-nav width-100 " +
              (user && user.profileName
                ? "header-links-profile"
                : "header-links")
            }
          >
            {user &&
              user.links &&
              user.links.length &&
              user.links.map((link: any, i: any) => {
                const itemKey = link.route || link.link || i;
                return (
                  <div key={`head${itemKey}`}>
                    <li className="nav-item">
                      <span
                        className={
                          "nav-link " + (active === link.route ? "active" : "")
                        }
                        onClick={() => {
                          if (link.link) {
                            navigateToRoute(false, link.link);
                          } else {
                            navigateToRoute(link.route);
                          }
                        }}
                      >
                        {link.label}{" "}
                      </span>
                    </li>
                  </div>
                );
              })}
            {!user ||
              (!user.email && (
                <li className="nav-item dropdown">
                  <span
                    key={"dropdown"}
                    className="nav-link dropdown-toggle primary-header-button mt-15 text-transform-none"
                    role="button"
                    id="dropdownMenuLink"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    STAY <em className="rewarded">Rewarded</em>
                  </span>
                  <div
                    className="dropdown-menu custom-dropdown"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <span
                      className="dropdown-item"
                      onClick={() => navigateToRoute("/signup")}
                    >
                      Join
                    </span>
                    <span
                      className="dropdown-item"
                      onClick={() => navigateToRoute("/login")}
                    >
                      Login
                    </span>
                    <span
                      className="dropdown-item"
                      onClick={() => {
                        navigateToRoute(
                          false,
                          INTERNAL_REDIRECTION_URLS.MPH_STAY_REWARDED
                        );
                      }}
                    >
                      About Stay Rewarded
                    </span>
                  </div>
                </li>
              ))}
            {user && user.profileName && <></>}{" "}
          </ul>
        </div>
        {user && user.profileName && (
          <div className="user-greet-desktop nav-item dropdown mr-4">
            <p
              key={"dropdown"}
              role="button"
              id="dropdownProfileLink"
              data-bs-toggle="dropdown"
              className="mb-0 user-name"
              aria-expanded="false"
            >
              Hi, {user.profileName} |{" "}
              {(user.loyalty_points || 0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
              Points{" "}
            </p>
            <div
              className="dropdown-menu custom-dropdown"
              aria-labelledby="dropdownProfileLink"
            >
              <span
                className="dropdown-item"
                onClick={() => navigateToRoute("/status")}
              >
                My Status
              </span>
              <span
                className="dropdown-item"
                onClick={() => navigateToRoute("/rewards")}
              >
                My Rewards
              </span>
              <span
                className="dropdown-item"
                onClick={() => {
                  clearStorage();
                  setUserProfile(null);
                  setOptIn(false);
                  navigate("/");
                }}
              >
                Logout
              </span>
            </div>
          </div>
        )}{" "}
        {user && user.profileName && (
          <div className="form-inline find-hotel">
            <MPHButton
              buttonText="Find Hotels"
              buttonType={"secondary-button"}
              onbuttonClick={() => navigateToRoute(null, INTERNAL_REDIRECTION_URLS.MPH_OUR_LOCATIONS)}
            />
          </div>
        )}
      </nav>
      <form
        ref={modifyReservationFormRef}
        action={redirectUrl}
        method="POST"
        style={{ display: "none" }}
      >
        <input type="hidden" name="hotel" defaultValue="" />
        <input
          type="hidden"
          name="chain"
          defaultValue={CHAIN_ID ? String(CHAIN_ID) : ""}
        />
        <input type="hidden" name="Level" defaultValue="Chain" />
        <input type="hidden" name="adult" defaultValue="" />
        <input type="hidden" name="arrive" defaultValue="" />
        <input type="hidden" name="depart" defaultValue="" />
        <input type="hidden" name="rooms" defaultValue="" />
        <input type="hidden" name="code-type" defaultValue="promo" />
        <input type="hidden" name="promo" defaultValue="" />
        <input type="hidden" name="locale" defaultValue="en_US" />
        <input type="hidden" name="UserType" defaultValue="Guest" />
        <input type="hidden" name="session" defaultValue="" />
      </form>
    </>
  );
};

export default MPHHeaderMain;
